import {createAsyncAction} from '../services/redux-toolkit'

export const getCheckoutOptions = createAsyncAction(
  'GET_CHECKOUT_OPTIONS',
  async (_, {getState, extra: {serverApi}}) => {
    if (!getState().checkoutOptions.loaded) {
      return serverApi.getCheckoutOptions()
    } else {
      return Promise.resolve()
    }
  },
)
